import StepCardV2 from './StepCardV2'

export default StepCardV2;